import { useUpdateEffect } from '@cian/react-utils';

import { useMapSelectedBoundsSelector } from 'shared/store/clientSide/slices/mapControls/selectors/dumb';
import { useGetClustersQuery } from 'shared/store/serverSide/commercial-listing-map/desktop/v2/map/get-clusters/query';
import { scrollToTopWithCallback } from 'shared/utils/scrollToTopWithCallback';

export function useGetClustersOnSelectedBoundsChange(): void {
  const selectedBounds = useMapSelectedBoundsSelector();

  const { refetch } = useGetClustersQuery();

  useUpdateEffect(() => {
    /**
     * Скроллим вверх страницы, когда нажимаем кнопку "Искать в этой области"
     */
    scrollToTopWithCallback(() => {
      refetch();
    });
  }, [selectedBounds]);
}
